import * as React from 'react';
import FormCheckbox from "../../atom/form/form_checkbox";
import styled from "styled-components";
import {ConstBorderRound, ConstColor} from "../../../../config/styles_const/styles_const";
import Paragraph from '../../atom/text/paragraph';

interface IProps {
    name: string;
    label: string;
    input?: any;
    checked: boolean;
}

const Checkbox: React.FC<IProps> = (props) => {

    const { name, label, input, checked} = props;

    return (
        <Wrapper>
            {!checked &&
                <ModifyIcon icon={'"\f044"'} iconPrefix={"400"}/>
            }
            <FormCheckbox
                {...input}
                id={name}
                type={"checkbox"}
                checked={checked}
                disabled={true}
            />
            <CheckboxLabel htmlFor={name} >
                <CheckboxLabelText bold={true}>
                    {label}
                </CheckboxLabelText>
            </CheckboxLabel>
        </Wrapper>
    );
};

export default Checkbox;

const height = "24px";

const ModifyIcon = styled(Paragraph)`
    color: ${ConstColor.Corporate};
    cursor:pointer;
    position: absolute;
    top: 0;
    left: 5px;
    &::before {
        margin-right: 0;
    }
`

const CheckboxLabelText = styled(Paragraph)`
    display: inline-block;
    color: ${ConstColor.Corporate};
`;

const CheckboxLabel = styled.label`
`;

const Wrapper = styled.div`
    display: flex;
    margin-bottom: 20px;
    min-height: ${height};
    position: relative;
    & ${FormCheckbox}{
        display: none;
    }
    & ${CheckboxLabel}{
        padding-left: 36px;
        padding-right: 5px;
        position:relative;
        height: ${height};
        display: flex;
        align-items: center;
        cursor: pointer;
        transition: all 0.3s ease;
        &:hover {
            background-color: rgba(154, 140, 100, 0.1);
            border-radius: ${ConstBorderRound.CornerRoundAll};
        }
    }
    & ${CheckboxLabel}::before{
        display: none;
    }
    & ${FormCheckbox}:checked + ${CheckboxLabel}::before{
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: ${height};
        height: ${height};
        background-color: ${ConstColor.White};
        border: 1px solid ${ConstColor.Success};
        border-radius: ${ConstBorderRound.BadgeBorder};
    }
    & ${FormCheckbox}:checked + ${CheckboxLabel}{
        ${CheckboxLabelText} {
            color: ${ConstColor.Gray};
        }
        cursor: initial;
        &:hover {
            background-color: ${ConstColor.White};
        }
    }
    & ${CheckboxLabel}::after{
        display: none;
    }
    & ${FormCheckbox}:checked + ${CheckboxLabel}::after{
        content: "";
        display: block;
        position: absolute;
        top: 6px;
        left: 6px;
        width: 12px;
        height: 8px;
        transform: rotate(-45deg);
        border-bottom: 2px solid ${ConstColor.Success};
        border-left: 2px solid ${ConstColor.Success};
    }  
`;


// WEBPACK FOOTER //
// ./src/presentation/common/molecular/checkbox/checkbox.tsx